import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const Discount = () => {
  return (
    <Container>
    <h2 className="display-6 fw-bold my-4">
    APC Discounts and Waivers
    </h2>
    <hr />

    <p className="joab-common-para my-4">
    The managing editor will assess applications submitted before article submission based on the quality of the research article and the authors’ ability to pay.
    </p>
   
  </Container>
  );
};

export default Discount;
